import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import './tabs.scss';

export const Tabs = (props) => {
  const { options } = props;

  const { i18n } = useTranslation();

  const navigate = useNavigate();

  const onClickTab = useCallback(
    (to) => () => {
      navigate(to?.replace(':language', i18n.language));
    },
    [navigate, i18n],
  );

  return (
    <div className="tabs">
      {options?.map((item) => (
        <div
          className={`tabs-item ${item.is_active ? 'active' : ''}`}
          key={item.to}
          onClick={onClickTab(item.to)}
        >
          {item.label}
        </div>
      ))}
    </div>
  );
};
